export default [
    {
        path: 'papel',
        component: () => import(
            /* webpackChunkName: 'administracao-papel' */
            '@/views/administracao/papel/Index'
        ),
        redirect: 'papel/index',
        children: [
            {
                name: 'administracao-papel-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'administracao-papel' */
                    '@/views/administracao/papel/List.vue'
                ),
            },
            {
                name: 'administracao-papel-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'administracao-papel' */
                    '@/views/administracao/papel/Form.vue'
                ),
            },
            {
                name: 'administracao-papel-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'administracao-papel' */
                    '@/views/administracao/papel/Form.vue'
                ),
            },
        ],
    },
]